import { render, staticRenderFns } from "./navTab.vue?vue&type=template&id=64e99627&scoped=true"
import script from "./navTab.vue?vue&type=script&lang=js"
export * from "./navTab.vue?vue&type=script&lang=js"
import style0 from "./navTab.vue?vue&type=style&index=0&id=64e99627&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64e99627",
  null
  
)

export default component.exports